import { createClient } from '@services/api'
import { UserReport } from './types'

export async function fetchUserReports({ queryKey }) {
  const [, params] = queryKey
  const { data } = await createClient().get<UserReport[]>(
    `/users/${params.userId}/reports/`
  )

  return data
}

export async function fetchPublicReports() {
  const { data } = await createClient().get<UserReport[]>(
    '/domoreports/public/'
  )

  return data
}
